import * as TYPES from '../types';

export const getAllAnnouncementAction = () => {
    return {
        type: TYPES.GET_ALL_ANNOUNCEMENTS,
    };
};

export const getAllAnnouncementSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_ANNOUNCEMENTS_SUCCESS,
        payload: payload
    };
};